import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import "./SiderComponent.css";
import Sider from "antd/es/layout/Sider";

const { Text, Title } = Typography;

const RightSiderComponent: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const SiderContent = () => (
    <div
      className={`right-sider-content ${isMobile ? "mobile" : ""}`}
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        boxSizing: "border-box",
        flexDirection: "column",
      }}>
      {!isMobile && (
        <Typography
          style={{
            fontSize: "20px",
            fontWeight: "700",
            color: "rgba(0,0,0,0.2)",
            textAlign: "center",
            marginBottom: "20px",
          }}>
          Instructions
        </Typography>
      )}
      <div style={{ flex: 1, overflow: "auto" }}>
        <div className="instructions-content">
          <Text
            style={{
              color: "#666",
              fontSize: "14px",
              display: "block",
              marginBottom: "16px",
            }}>
            Use MP3 upload or Live Stream to transcribe audio.
          </Text>
          <Title level={5} style={{ color: "#333", marginBottom: "12px" }}>
            How to use:
          </Title>
          <ul
            style={{
              color: "#666",
              fontSize: "13px",
              lineHeight: "1.6",
              paddingLeft: "16px",
              margin: 0,
            }}>
            <li style={{ marginBottom: "8px" }}>
              MP3 Upload: choose a file (≤ 25MB) and click "Upload & Transcribe".
            </li>
            <li style={{ marginBottom: "8px" }}>
              Live Stream (non-compare): click "Start Recording". Streaming continues until you click "Stop Recording". The transcript builds live and resets when you start again.
            </li>
            <li style={{ marginBottom: "8px" }}>
              Live Stream (compare): for "breeze" models, transcripts stream live. For other models, we listen for speech and, on pause, we stop recording, upload the buffered audio, and then display each model’s result.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );

  // If rendered within a drawer, don't use Sider component
  if (isMobile) {
    return <SiderContent />;
  }

  return (
    <Sider
      width={400}
      className="RightSider"
      style={{
        background: "#fff",
        borderLeft: "1px solid rgba(0,0,0,0.1)",
      }}>
      <SiderContent />
    </Sider>
  );
};

export default RightSiderComponent;